module.exports = __webpack_public_path__ + "static/workshop-nav@2x-7ec05d5fe3d476739e3d47833e3f8956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/workshop-nav@2x.jpg
// module id = 2705
// module chunks = 168707334958949